import gsap from 'gsap';

const loader = document.querySelector('.page-transistion');
// reset position of the loading screen
gsap.set(loader, {
    scaleX: 0,
    xPercent: 5,
    yPercent: -50,
    transformOrigin: 'right center',
    autoAlpha: 1
});

function loaderIn() {
    const tl = gsap.timeline();

    // page-transistion Animation
    tl.fromTo(loader,
        {
            // rotation: 10,
            scaleX: 0,
            xPercent: 5
        },
        {
            duration: 0.8,
            xPercent: 0,
            scaleX: 1,
            // rotation: 0,
            ease: 'Power4.inOut',
            transformOrigin: 'right center'
        });

    return tl;
}

function loaderAway() {
    const tl = gsap.timeline();

    tl.to(loader, {
        duration: 0.8,
        scaleX: 0,
        xPercent: -5,
        // rotation: -10,
        transformOrigin: 'left center',
        ease: 'Power4.inOut'
    });

    return tl;
}

export { loaderIn, loaderAway };
